import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer gd-footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>GoaDeals Travel Services</h3>
            <p className="gd-footer-desc">
              Customised Goa tour packages, hotel stays, private transfers, North and South Goa
              sightseeing, dinner cruises, adventure activities, Dudhsagar trips, and group travel.
            </p>
            <div className="contact-info">
              <p><i className="fas fa-phone" /> +91 945 945 7733</p>
              <p><i className="fas fa-envelope" /> Info@goadeals.in</p>
              <p><i className="fas fa-map-marker-alt" /> Calangute, North Goa, India</p>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <div className="footer-links">
              <Link to="/packages">Goa Packages</Link>
              <Link to="/hotels-list">Hotel Booking</Link>
              <Link to="/tours">Sightseeing</Link>
              <Link to="/activities">Activities</Link>
              <Link to="/#faqs">FAQs</Link>
              <Link to="/#contact">Contact Us</Link>
            </div>
          </div>

          <div className="footer-section">
            <h3>Follow Us</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/profile.php?id=61579083303957" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook" />
              </a>
              <a href="https://www.instagram.com/goadeals27/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram" />
              </a>
              <a href="https://www.linkedin.com/company/109024025/admin/dashboard/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <i className="fab fa-linkedin" />
              </a>
              <a href="https://wa.me/919459457733" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
                <i className="fab fa-whatsapp" />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} GoaDeals Travel Services. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
